import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=0ecf3a0a&scoped=true"
import script from "./comment.vue?vue&type=script&lang=js"
export * from "./comment.vue?vue&type=script&lang=js"
import style0 from "./comment.vue?vue&type=style&index=0&id=0ecf3a0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecf3a0a",
  null
  
)

export default component.exports